<script>
import Multiselect from 'vue-multiselect'
import api from '@/helpers/api'
export default {
  name: 'shop-select',
  props: {
    value: { type: [Array, String] },
    multiple: { type: Boolean, default: true }
  },
  components: {
    Multiselect
  },
  data: vm => ({
    shops: [],
    selected: null
  }),
  methods: {
    async loadData () {
      let { items } = await api.shops.fetchPage({
        page: 1,
        pageSize: -1,
        filters: [{ is_active: { _eq: true } }]
      })

      this.shops = [...items]
    },
    onSelected (items) {
      let id
      if (!items) return this.emitChanges(null)
      if (this.multiple) {
        id = items.map(s => s.id)
      } else {
        id = items.id
      }
      this.emitChanges(id)
    },
    emitChanges (v) {
      this.$emit('input', v)
      this.$emit('select', v)
    }
  },
  watch: {
    value: {
      async handler (val) {
        if (this.shops.length <= 0) {
          await this.loadData()
        }

        if (!val) return
        if (this.multiple) {
          this.selected = this.shops.filter(s => val.includes(s.id))
        } else {
          this.selected = this.shops.find(s => s.id == val)
        }
      },
      immediate: true
    }
  },
  computed: {
    listeners () {
      return { ...this.$listeners, select: 'onSelected' }
    }
  }
}
</script>
<template>
  <Multiselect
    :options="shops"
    :custom-label="({ id, name }) => `${name}`"
    track-by="id"
    v-model="selected"
    :placeholder="$attrs.placeholder || 'Select a Shop'"
    :show-labels="true"
    :allow-empty="true"
    v-bind="$attrs"
    v-on:input="onSelected"
    v-on:close="$emit('blur')"
    :multiple="multiple"
  ></Multiselect>
</template>

<style lang="scss">
.multiselect__content-wrapper {
  overflow-x: hidden;
}
</style>
